import { ComponentConfigProps, FilterData } from "../typing";
import FilterItemBanks from "./Banks";
import FilterItemCategory from "./Category";
import FilterItemPrograms from "./Programs";

/**
 * 注册的filter项目
 */
export const filterRegisterList: ComponentConfigProps[] = [
  {
    key: "departure",
    label: "Departure",
    defaultValue: [],
  },
  {
    key: "arrival",
    label: "Arrival",
    defaultValue: [],
  },
  {
    key: "programs",
    label: "Programs",
    component: FilterItemPrograms,
    defaultValue: [],
  },
  {
    key: "banks",
    label: "Cards",
    component: FilterItemBanks,
    defaultValue: [],
  },
  {
    key: "category",
    label: "Category",
    component: FilterItemCategory,
    defaultValue: [],
  },
];

/**
 * 获取所有filter的默认值
 * @returns
 */
export const getFilterDefault = () => {
  return filterRegisterList.reduce((result, item) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    result[item.key] = item.defaultValue;
    return result;
  }, {} as FilterData);
};

export const getFilterConfigByKey = (key: string): ComponentConfigProps | undefined => {
  return filterRegisterList.find((item) => item.key === key);
};
